import { useEffect, useState, useCallback } from 'react';
import accountApis from '../../../../services/accountApis';

const useGetAllStore = (isLazy = false) => {
  const [data, setData] = useState<any[]>([]);

  const fetchData = useCallback(async () => {
    try {
      const response = await accountApis.filterSalon(null, null, 1, 10000);

      if (response?.status === 200) {
        setData(response.data.data.content);
      }
    } catch (error) {
      console.error(error);
    } 
  }, []);

  useEffect(() => {
    if (!isLazy) {
      fetchData();
    }
  }, [isLazy, fetchData]);

  return {
    data,
    refetch: fetchData,
  };
};

export default useGetAllStore;